import { Component, Input, inject } from "@angular/core";
import { GlobalErrorService } from "../ErrorService";
import { AppButtonComponent } from "../../../Common/Components/Button/ButtonComponent";

/**
 * Wraps arbitrary content and replaces it with a full-screen overlay when GlobalErrorService
 * reports an error. The overlay shows the error message and two recovery paths:
 * - Try again: clears the error and forces a page reload for a clean bootstrap.
 * - Dismiss: clears the error and returns to the underlying UI without reloading.
 * When no error exists, the component simply renders its projected children.
 */
@Component({
  selector: "app-error-boundary",
  standalone: true,
  imports: [AppButtonComponent],
  templateUrl: "./ErrorBoundary.html",
  styleUrl: "./ErrorBoundary.scss",
})
export class ErrorBoundaryComponent {
  @Input() title = "Please refresh the page";
  public readonly errors = inject(GlobalErrorService);

  reset(): void {
    this.errors.clear();
    location.reload();
  }

  dismiss(): void {
    this.errors.clear();
  }
}
